/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import { HcoCoreFragmentDoc } from '../Hco/HCOCore.hook';
import { NotFoundErrorFragmentDoc } from '../core.hook';
export type AddressSummaryFragment = {
	__typename?: 'Address';
	vid_V: string;
	primaryCda_V?: boolean | null;
	cityCda_V?: string | null;
	cityIntl_V?: string | null;
	stateCda_V?: string | null;
	countryCda_V?: string | null;
	streetAddress1Cda_V?: string | null;
	streetAddress1Intl_V?: string | null;
	postalCodeCda_V?: string | null;
	postalCodeIntl_V?: string | null;
};

export type AddressFragment = {
	__typename?: 'Address';
	streetAddress1Cda_V?: string | null;
	streetAddress1Intl_V?: string | null;
	streetAddress2Cda_V?: string | null;
	streetAddress2Intl_V?: string | null;
	postalCodeCda_V?: string | null;
	postalCodeIntl_V?: string | null;
	postalCodeFullUs_V?: string | null;
	cbsa_V?: string | null;
	latitudeCda_V?: number | null;
	longitudeCda_V?: number | null;
	statusCda_V?: string | null;
	statusCda_VId?: string | null;
	subStateAdminUnit_V?: string | null;
	businessCda_V?: boolean | null;
	dpvConfirmedIndicator_V?: string | null;
	buildingIdentifier_V?: string | null;
	phoneCda_V?: string | null;
	faxCda_V?: string | null;
	vid_V: string;
	primaryCda_V?: boolean | null;
	cityCda_V?: string | null;
	cityIntl_V?: string | null;
	stateCda_V?: string | null;
	countryCda_V?: string | null;
	hospitalCampus?:
		| {
				__typename?: 'HCO';
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				displayName_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| { __typename?: 'ResourceNotFound'; message: string }
		| null;
};

export const AddressSummaryFragmentDoc = gql`
	fragment AddressSummary on Address {
		vid_V
		primaryCda_V
		cityCda_V
		cityIntl_V
		stateCda_V
		countryCda_V
		streetAddress1Cda_V
		streetAddress1Intl_V
		postalCodeCda_V
		postalCodeIntl_V
	}
`;
export const AddressFragmentDoc = gql`
	fragment Address on Address {
		...AddressSummary
		streetAddress1Cda_V
		streetAddress1Intl_V
		streetAddress2Cda_V
		streetAddress2Intl_V
		postalCodeCda_V
		postalCodeIntl_V
		postalCodeFullUs_V
		cbsa_V
		latitudeCda_V
		longitudeCda_V
		statusCda_V
		statusCda_VId
		subStateAdminUnit_V
		businessCda_V
		dpvConfirmedIndicator_V
		buildingIdentifier_V
		phoneCda_V
		faxCda_V
		hospitalCampus {
			... on HCO {
				...HCOCore
				addresses(includeInactive: true) {
					...AddressSummary
				}
			}
			...NotFoundError
		}
	}
	${AddressSummaryFragmentDoc}
	${HcoCoreFragmentDoc}
	${NotFoundErrorFragmentDoc}
`;
